var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsIn, IsOptional, IsString, ValidateNested } from 'class-validator';
import { AppointmentResponseDto } from '../../appointments/dto/appointment.response.dto.js';
import { TreatmentProgressDto } from './treatment-progress.dto.js';
export class CalendarAppointmentViewDto extends AppointmentResponseDto {
    kind;
    /**
     * `true` when this row's `ruleVersion` is older than its parent series's
     * current `ruleVersion` — i.e. the row was materialized before a later
     * rrule edit and now sits as an "orphaned override". Always `false` for
     * non-series rows and for virtual occurrences (which carry the series's
     * current `ruleVersion` by construction).
     */
    isCustomized;
    treatmentProgress;
    /**
     * The plans the appointment's units belong to — the ones `treatmentProgress`
     * counts in. Empty for an unlinked appointment and for a virtual occurrence.
     */
    treatmentPlanIds = [];
    /**
     * A virtual occurrence's patients, from the series defaults — it has no
     * participant rows yet. Empty for materialized rows, whose `participants` say it.
     */
    seriesParticipantPatientIds = [];
}
__decorate([
    IsIn(['materialized', 'virtual']),
    Expose(),
    __metadata("design:type", String)
], CalendarAppointmentViewDto.prototype, "kind", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], CalendarAppointmentViewDto.prototype, "isCustomized", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => TreatmentProgressDto),
    Expose(),
    __metadata("design:type", Object)
], CalendarAppointmentViewDto.prototype, "treatmentProgress", void 0);
__decorate([
    IsArray(),
    IsString({ each: true }),
    Expose(),
    __metadata("design:type", Array)
], CalendarAppointmentViewDto.prototype, "treatmentPlanIds", void 0);
__decorate([
    IsArray(),
    IsString({ each: true }),
    Expose(),
    __metadata("design:type", Array)
], CalendarAppointmentViewDto.prototype, "seriesParticipantPatientIds", void 0);
//# sourceMappingURL=calendar-appointment-view.dto.js.map